export default "__VITE_ASSET__R1A8iySx__"